module.exports = __webpack_public_path__ + "img/ANTENNA 5 BW.1ad3fc7.svg";